import { useEffect, useState } from "react";

import SearchInput from "common/components/SearchInput";
import useDebounce from "common/hooks/useDebounce";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function SearchLeads({
  setKeywords,
}: {
  setKeywords: (keywords: string) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const [inputValue, setInputValue] = useState("");
  const [debouncedValue] = useDebounce(inputValue);

  useEffect(() => {
    setKeywords(debouncedValue);
  }, [debouncedValue]);

  return (
    <SearchInput
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onClear={() => setInputValue("")}
      className="lg:w-72"
      placeholder="Search leads"
      variant={isDesktop ? "sm" : "lg"}
    />
  );
}
